import { useUser } from "../contexts/UserContext";

export const getProfileImageUrl = () => {
  const { user } = useUser();
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGEURL;

  if (user?.image) {
    return user.image.startsWith("http")
      ? user.image // if backend sends absolute URL
      : `${IMAGE_BASE_URL}/${user.image}`;
  }

  return `${IMAGE_BASE_URL}/uploads/no_image.png`;
};

